import jsonFromDocument from "cerulean/src/JsonFromDocument";

export const CSRF_TOKEN: string = jsonFromDocument("csrf_token");
